module.exports = __webpack_public_path__ + "img/Who owns the city.65a2f15e.jpg";